import { REMOVE_BASKET, REMOVE_BASKET_ERROR, REMOVE_BASKET_SUCCESS } from "core-web/state/models/Basket/constants";

import { BasketEvents } from "core-web/libs/Events/constants";
import Cookies from "js-cookie";
import Events from "core-web/libs/Events";
import { acquireMutex } from "core-web/state";
import store from "core-web/state/store";

export const removeBasket = () => async (dispatch) => {
    const mutexLock = await acquireMutex("basket.getBasket");
    dispatch({ type: REMOVE_BASKET });
    try {
        Cookies.remove("giftcard_balance");
        Cookies.remove("basket_id");
        Cookies.remove("basket_items_amount");

        dispatch({ type: REMOVE_BASKET_SUCCESS });

        Events.trigger(BasketEvents.UPDATED);

        mutexLock();
    } catch (e) {
        dispatch({ type: REMOVE_BASKET_ERROR });

        mutexLock();

        throw e;
    }
};

export default () => store.dispatch(removeBasket());
